import React from 'react'
import ReactModal from 'react-modal'
import ApproveDeny from './ApproveDeny'
import useIsMobile from 'Hooks/useIsMobile'

function ApproveDetailsPage({uploadNew, onClose, doNotClose = true, item, setUpdateList, initialDeny = false}) {
  const isMobile = useIsMobile();
  return (
    <ReactModal
    shouldCloseOnEsc = {doNotClose}
    shouldCloseOnOverlayClick = {doNotClose}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 30,
          backgroundColor: 'rgba(20,33,61,.45)'
        },
        content: {
            zIndex: 30,
            width: isMobile ? 'calc(100% - 24px)' : '760px',
            maxWidth: '100%',
            height: 'auto',
            maxHeight: 'calc(100vh - 60px)',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: 0,
            border: 'none',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 20px 50px rgba(20,33,61,.25)',
        }
      }}
    >
        <ApproveDeny item = {item} setUpdateList={setUpdateList} onClose={onClose} initialDeny={initialDeny}/>
    </ReactModal>
  )
}

export default ApproveDetailsPage
